var DepartmentIssueTypes;
(function (DepartmentIssueTypes) {
    DepartmentIssueTypes["DEVICE_OFFLINE"] = "deviceOffline";
    DepartmentIssueTypes["MEASURED_DATA_ALARM"] = "measuredDataAlarm";
    DepartmentIssueTypes["GROUP_MEASURED_DATA_ALARM"] = "groupMeasuredDataAlarm";
    DepartmentIssueTypes["LOW_BATTERY"] = "lowBattery";
    DepartmentIssueTypes["SOURCE_OFFLINE"] = "sourceOffline";
})(DepartmentIssueTypes || (DepartmentIssueTypes = {}));
export default DepartmentIssueTypes;
